import { X } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function PreviewModal({ product, activeView, currentImage, currentZone, allImages, selectedFinish, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/85 backdrop-blur-md p-4" data-testid="preview-modal" onClick={onClose}>
      <div className="relative max-w-2xl w-full max-h-[90vh]" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} data-testid="preview-close-btn"
          className="absolute -top-10 right-0 z-10 w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 transition-colors">
          <X className="w-4 h-4" />
        </button>

        <div className="aspect-square bg-white rounded-2xl relative overflow-hidden shadow-2xl">
          {currentImage ? (
            <img src={`${API}/api/files/${currentImage}`} alt={product?.title || 'Product preview'}
              className="w-full h-full object-contain p-[8%]" data-testid="preview-product-image" />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-slate-400 text-sm">No image available</div>
          )}

          {/* All image overlays — no print zone lines */}
          {currentZone && allImages?.map((imgItem) => (
            <div key={imgItem.id} className="absolute"
              style={{ left: `${currentZone.x}%`, top: `${currentZone.y}%`, width: `${currentZone.width}%`, height: `${currentZone.height}%` }}>
              <div className="absolute"
                style={{
                  left: `${imgItem.logoPlacement.x}%`, top: `${imgItem.logoPlacement.y}%`,
                  width: `${imgItem.logoPlacement.width}%`, height: `${imgItem.logoPlacement.height}%`,
                }}>
                <img src={imgItem.userLogo} alt="Design" className="w-full h-full object-contain"
                  style={{ transform: `rotate(${imgItem.logoPlacement.rotation || 0}deg) scaleX(${imgItem.logoPlacement.flipH ? -1 : 1})` }}
                  data-testid={`preview-logo-${imgItem.id}`} />
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-xs text-white/50 mt-4">
          {product?.title} {activeView?.name && `— ${activeView.name}`}
          {selectedFinish && ` · ${selectedFinish.label}`}
        </p>
      </div>
    </div>
  );
}
